
import { FrxBaseBean } from './frxbasebean';
export class Person extends FrxBaseBean {

	address: string;
	egn: string;
	email: string;
	legalEntity: boolean;
	insurer: boolean;
	obshtina: boolean;
	name: string;
	note: string;
	phone: string;
	info: string;

	copy(source: Person) {
		super.copy(source);
		this.address = source.address;
		this.egn = source.egn;
		this.email = source.email;
		this.name = source.name;
		this.legalEntity = source.legalEntity;
		this.insurer = source.insurer;
		this.obshtina = source.obshtina;
		this.phone = source.phone;
		this.info = source.info;
	}
}